document.addEventListener('DOMContentLoaded', () => {
  const currentProductTitle = document.querySelector('h1')?.textContent.trim() || '';

  // Feature map based on Figma designs & actual products
  const featureMap = {
    'Facewash': {
      category: 'CLEANSE',
      tags: ['Unclog Pores', 'Twice Daily', 'Remove Oil']
    },
    'Face Wash': {
      category: 'CLEANSE',
      tags: ['Unclog Pores', 'Twice Daily', 'Remove Oil']
    },
    'Anti Acne Gel': {
      category: 'TREAT',
      tags: ['Target Active Acne', 'Twice Daily']
    },
    'Spots Reduction': {
      category: 'REPAIR',
      tags: ['Target Fades Marks', 'Twice Daily']
    },
    'Combo': {
      category: 'CLEANSE',
      tags: ['Unclog Pores', 'Twice Daily', 'Remove Oil'] // Fallback to step 1 tags
    }
  };

  function getFeatures(title) {
    if (!title) return { category: 'STEP', tags: [] };
    for (const key in featureMap) {
      if (title.toLowerCase().includes(key.toLowerCase())) {
        return featureMap[key];
      }
    }
    return { category: 'PRODUCT', tags: ['Daily Use'] };
  }

  function overhaulWebrex() {
    const mainContainer = document.querySelector('#ws_up_sell_main_container_0 .ws_up_sell_main');
    if (!mainContainer) return false;

    if (mainContainer.dataset.overhauled) return true;
    mainContainer.dataset.overhauled = 'true';

    // 1. Structure the grid
    // Target the actual slide elements based on the HTML dump
    const productCards = Array.from(mainContainer.querySelectorAll('.single-slide'));

    productCards.forEach((card, index) => {
      card.classList.add('alite-webrex-card');

      // Step number
      const stepNum = document.createElement('div');
      stepNum.className = 'alite-step-num';
      stepNum.textContent = index + 1;
      card.appendChild(stepNum);

      // Find title
      const titleEl = card.querySelector('.product-preview-title');
      const titleText = titleEl ? titleEl.textContent.trim() : '';

      // Is Current Product?
      const isCurrent = titleText && (currentProductTitle.toLowerCase().includes(titleText.toLowerCase()) || titleText.toLowerCase().includes(currentProductTitle.toLowerCase().split(' |')[0]));

      if (isCurrent) {
        card.classList.add('is-current-step');

        const badge = document.createElement('div');
        badge.className = 'alite-here-badge';
        badge.innerHTML = 'HERE YOU ARE ✓';
        card.appendChild(badge);
      }

      // Inject Category & Tags
      const features = getFeatures(titleText);

      const catPill = document.createElement('div');
      catPill.className = 'alite-category-pill';
      catPill.textContent = features.category;

      const img = card.querySelector('.single-product-image');
      if (img && img.parentElement) {
        img.parentElement.after(catPill);
      } else {
        card.prepend(catPill);
      }

      if (features.tags.length > 0) {
        const tagsContainer = document.createElement('div');
        tagsContainer.className = 'alite-feature-tags';
        features.tags.forEach(t => {
          const span = document.createElement('span');
          span.className = 'alite-feature-tag';
          span.textContent = '+ ' + t;
          tagsContainer.appendChild(span);
        });

        if (titleEl) {
          titleEl.after(tagsContainer);
        }
      }

      // Change Rs. to ₹ in prices
      const prices = card.querySelectorAll('.original-price, .discounted-price');
      prices.forEach(p => {
        p.textContent = p.textContent.replace('Rs.', '₹');
      });

      // Insert + Divider if not last
      if (index < productCards.length - 1) {
        const divider = document.createElement('div');
        divider.className = 'alite-step-divider';
        divider.textContent = '+';
        card.after(divider);
      }
    });

    // Clean up internal button duplicates if Webrex added them inside cards
    mainContainer.querySelectorAll('.single-slide .individual-button-container').forEach(el => el.remove());

    // 2. Overhaul Bottom Banner
    const containerWrapper = document.querySelector('#ws_up_sell_main_container_0');

    // Create our new banner container
    const newBanner = document.createElement('div');
    newBanner.className = 'alite-webrex-banner';

    // Find MAIN ATC button (class subDiv_button add-to-cart-button)
    const atcBtn = containerWrapper.querySelector('.subDiv_button.add-to-cart-button');
    if (atcBtn) {
      atcBtn.classList.add('alite-webrex-atc');
      // Look for inner text span
      const innerText = atcBtn.querySelector('.ws-button-text');
      if (innerText) {
        innerText.textContent = 'ADD TO CART';
      } else {
        atcBtn.textContent = 'ADD TO CART';
      }

      // Move the button to banner
      const btnWrapper = atcBtn.parentElement;
      if (btnWrapper && btnWrapper.classList.contains('ws_up_sell_subDiv')) {
        newBanner.appendChild(btnWrapper);
      } else {
        newBanner.appendChild(atcBtn);
      }
    }

    // Extract or Calculate total price
    let totalPriceStr = '';
    const totalEl = containerWrapper.querySelector('.ws-total-price, .total_price_wrapper');
    if (totalEl) {
      totalPriceStr = totalEl.textContent;
    } else {
      let total = 0;
      productCards.forEach(card => {
        const pEl = card.querySelector('.discounted-price, .original-price:not([style*="line-through"])');
        if (pEl) {
          const val = parseFloat(pEl.textContent.replace(/[^0-9.]/g, ''));
          if (!isNaN(val)) total += val;
        }
      });
      if (total > 0) {
        totalPriceStr = '₹' + total.toFixed(2);
      }
    }

    // Inject new layout
    const bannerContent = document.createElement('div');
    bannerContent.className = 'alite-banner-content';

    let savingsText = '(Save 10%)';

    bannerContent.innerHTML = `
      <h3>Complete Routine Combo</h3>
      <p>All ${productCards.length} for <strong>${totalPriceStr}</strong> ${savingsText}</p>
    `;

    const manImg = document.createElement('img');
    manImg.className = 'alite-banner-man';
    manImg.src = 'https://cdn.shopify.com/s/files/1/0805/0121/1430/files/Routine_Combo_Man.png';
    manImg.onerror = () => { manImg.style.display = 'none'; };

    newBanner.prepend(bannerContent);
    newBanner.prepend(manImg);

    containerWrapper.appendChild(newBanner);

    return true;
  }

  // Observers to catch Webrex injecting DOM
  const observer = new MutationObserver((mutations, obs) => {
    if (document.querySelector('#ws_up_sell_main_container_0 .ws_up_sell_main')) {
      if (overhaulWebrex()) {
        obs.disconnect(); // Done
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

  // Fallback poller
  let checkCount = 0;
  const interval = setInterval(() => {
    if (document.querySelector('#ws_up_sell_main_container_0 .ws_up_sell_main')) {
      if (overhaulWebrex()) {
        clearInterval(interval);
      }
    }
    checkCount++;
    if (checkCount > 100) clearInterval(interval); // Stop after 10 seconds
  }, 100);
});
